import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import './lmx.scss'
import Typography from '../../UniformComponents/Typography'

export default class LMX extends Component {
    renderOverlay = (items, className) => (
        items.length ? (
            <div className={`benchmarkData ${className}`} style={{ flex: '50%' }}>
                {items.map((b) => (
                    <div className="benchmark">
                        <div className="benchmarkName">{b.name}</div>
                        <div className="benchmarkValue">{b.value}</div>
                    </div>
                ))}
            </div>
        ) : null
    )

    renderDataBlocks = (data) => {
        const { compact } = this.props
        return (
            <div className={`dataBlock ${data.name}`}>
                <div className="dataContainer">
                    <div className="mainData" style={!compact ? { flex: '50%' } : {}}>
                        <div className={`subText ${data.name}`}>
                            {data.name}
                        </div>

                        <div className="mainText">
                            {data.value}
                        </div>

                        {compact ? null : (
                            <div style={{ display: 'flex', gap: 10, height: '100%' }}>
                                {this.renderOverlay(R.pathOr([], ['comparisonYears'], data), 'comparisonYearsData')}
                                {this.renderOverlay(R.pathOr([], ['benchmarks'], data), 'benchmarksData')}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { style, chartData } = this.props

        return (
            <div className="pp-lmx" style={{ height: '400px', width: '500px', ...style }}>
                <div className="pp-lmxContainer">
                    <div className="pp-lmxGraph">
                        <Typography cssClass="yLabel">Loyalty</Typography>
                        <Typography cssClass="xLabel">Satisfaction</Typography>
                        {chartData[0] ? this.renderDataBlocks(chartData[0]) : null}
                        {chartData[1] ? this.renderDataBlocks(chartData[1]) : null}
                        {chartData[2] ? this.renderDataBlocks(chartData[2]) : null}
                        {chartData[3] ? this.renderDataBlocks(chartData[3]) : null}
                    </div>
                </div>
            </div>
        )
    }
}

LMX.propTypes = {
    style: PropTypes.object,
    compact: PropTypes.bool,
    chartData: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            value: PropTypes.string,
            benchmarks: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string,
                    value: PropTypes.string,
                }),
            ),
            comparisonYears: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string,
                    value: PropTypes.string,
                }),
            ),
        }),
    ),
}

LMX.defaultProps = {
    style: {},
    chartData: [],
    compact: false,
}
